import type { ApiResponse, ComplianceSummary } from "./types";
import { bearerToken } from "./auth/keycloak";

// Base URL of the Flask backend. Defaults to prod. Override via
// VITE_API_BASE (e.g. http://localhost:5050 in .env.local for dev).
const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  "https://deliveryhub.rbsprod.net";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = bearerToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(init?.headers as Record<string, string> | undefined),
  };

  const resp = await fetch(`${API_BASE}${path}`, { ...init, headers });

  if (resp.status === 401) {
    throw new Error(
      "Unauthorized. Your Keycloak session may have expired - reload the page to sign in again.",
    );
  }
  if (!resp.ok) throw new Error(`HTTP ${resp.status} ${resp.statusText}`);

  const body = (await resp.json()) as ApiResponse<T>;
  if (!body.success || body.data === undefined) {
    throw new Error(body.error || "Unknown error");
  }
  return body.data;
}

export const api = {
  getSummary(): Promise<ComplianceSummary> {
    return request<ComplianceSummary>("/api/compliance/summary");
  },
  refresh(): Promise<ComplianceSummary> {
    return request<ComplianceSummary>("/api/compliance/refresh", { method: "POST" });
  },
};
